/**
 * Append Contentful Images API params to an asset URL so the CDN returns a
 * resized, modern-format image instead of the full-resolution original.
 *
 * Needed because static export forces `images.unoptimized: true`, which makes
 * `next/image` ignore custom loaders — so resizing has to happen via the URL.
 *
 * Non-Contentful URLs (e.g. S3) are returned unchanged.
 */
export function ctfImage(
	url: string | undefined | null,
	opts: {
		width?: number;
		height?: number;
		quality?: number;
		fit?: 'fill' | 'pad' | 'scale' | 'crop' | 'thumb';
		format?: 'webp' | 'avif' | 'jpg' | 'png';
	} = {}
): string {
	if (!url) return '';
	if (!url.includes('ctfassets.net')) return url;

	const [base, existing] = url.split('?');
	const params = new URLSearchParams(existing);

	params.set('fm', opts.format ?? 'webp');
	params.set('q', String(opts.quality ?? 70));
	if (opts.width) params.set('w', String(opts.width));
	if (opts.height) params.set('h', String(opts.height));
	if (opts.fit) params.set('fit', opts.fit);

	return `${base}?${params.toString()}`;
}
